import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Engineeri8DataService } from '@monorepo/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, from, map, of, switchMap } from 'rxjs';
import {
  FetchAllMethods,
  FetchAllMethodsFailure,
  FetchAllMethodsSuccess,
  FetchAllOBs,
  FetchAllOBsFailure,
  FetchAllOBsSuccess,
} from './library.action';
import { LibraryActionType } from './library.models';

@Injectable({ providedIn: 'root' })
export class LibraryEffects {
  constructor(
    private actions$: Actions,
    private appNotificationUtilClass: AppNotificationUtilClass,
    private engineeri8DataService: Engineeri8DataService,
  ) {}

  fetchAllMethods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LibraryActionType.FetchAllMethods),
      exhaustMap((action: FetchAllMethods) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          switchMap((loaderEl) =>
            this.engineeri8DataService.fetchAllMethods(action.payload).pipe(
              map((res) => new FetchAllMethodsSuccess(res)),
              catchError(() => of(new FetchAllMethodsFailure())),
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
            ),
          ),
        ),
      ),
    ),
  );

  fetchAllOBs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LibraryActionType.FetchAllOBs),
      exhaustMap((action: FetchAllOBs) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          switchMap((loaderEl) =>
            this.engineeri8DataService.fetchAllOBs(action.payload).pipe(
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
              map((res) => new FetchAllOBsSuccess(res)),
              catchError(() => of(new FetchAllOBsFailure())),
            ),
          ),
        ),
      ),
    ),
  );
}
